import {useAMap} from "../mixins/amap"
import {useStatusHandler} from "../mixins/status_handler"

export default class extends ApplicationController {
    static targets = ["lnglatOutput", "status"]
    static values = {location: Object, trackPath: Array, status: String}

    connect() {
        useAMap(this)
        useStatusHandler(this)

        this.initMap()

        let point = this.locationValue
        this.lnglatOutputTarget.innerHTML = `${point.x}, ${point.y}`
    }

    initMap() {
        this.loadMap("map", 20, (map) => {
            this.map = map

            this.makePathOnMap(this.map, this.trackPathValue)
            this.marker = this.makeMarkerOnMap(this.map, this.locationValue)
        })
    }
}